const ConvexHull = () => {
    return (
        <>
            <h1>Convex Hull</h1>
        </>);
}

export default ConvexHull;